import React from 'react';
import { BrowserRouter as Router, Link, Redirect, Route, Switch } from "react-router-dom";
import { slide as Menu } from 'react-burger-menu';
import PreloginHome from '../../prelogin/src/PreloginHome';
import ComponentRegistry from '../../model/ComponentRegistry.js';
import StaticFeed from '../../prelogin/src/components/StaticFeed';
import ScrollToTopOnMount from '../../prelogin/src/components/ScrollToTopOnMount.js';
import Banner from './ke_Banner.js';
import RecognisedStatic from '../../prelogin/src/components/ke_RecognisedStatic';
import OurTeachers from '../../prelogin/src/components/OurTeachers.js';
import SignupSection from '../../prelogin/src/components/SignupSection2.js';
import LessonFeatures from '../../prelogin/src/components/LessonFeatures2.js';
import OurTestimonial from '../../prelogin/src/components/OurTestimonial.js';
import Footer from './ke_Footer.js';
import Why from '../../prelogin/src/components/Why.js';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import Dashboard from '../../views/dashboard/Dashboard';
import Scorecard from '../../views/scorecard/Scorecard';
import Home from '../../views/plp/Home';
import Spotlight from '../../prelogin/src/components/ke_Spotlight.js';
import WhoBanner from '../../prelogin/src/components/WhoBanner2.js';
import DayInLife from '../../prelogin/src/components/DayInLife.js';
import Culture from '../../prelogin/src/components/Culture.js';

import FAQ from '../../prelogin/src/components/FAQ';

import HmEventRegistry from '../../model/HmEventRegistry';
import PageBanner from '../../prelogin/src/components/PageBanner.js';
import FlipSection from '../../prelogin/src/components/FlipSection.js';
import OtherLearnings from '../../prelogin/src/components/OtherLearnings.js';
import Founders from '../../prelogin/src/components/Founders.js';
import Teampage from '../../prelogin/src/components/Teampage';
import FounderVideos from '../../prelogin/src/components/FounderVideos.js';
import Recognised from '../../prelogin/src/components/Recognised.js';

let promotionMessage = (window.promotionMessage) ? window.promotionMessage : {};

class ke_PreloginHome extends PreloginHome {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        super.componentWillMount();
    }

    componentDidMount() {
        //console.warn("PreloginHome KE");
        super.componentDidMount();
        this.appendCSS("/vendors/ke_main.css");  
    }

    Learnings() {
            this.setTitle("LEARNINGS_title");
    
            HmEventRegistry.fireEvent("INITIATE_GA");
            HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
            this.selectedMenu = "menuourlearnings";
            return (
                <div>
                    <ScrollToTopOnMount />
                    {/*<PageBanner name="Our Learnings" classes="bg-grn bg-blue banner-text" text={this.rb("our_learnings_heading")}></PageBanner>*/}
                    <PageBanner classes="bg-grn bg-blue banner-text" text={this.rb("our_learnings_heading")}></PageBanner>
                    <FlipSection></FlipSection>
                    <OtherLearnings></OtherLearnings>
                    <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
                </div>
            );
    }

    Spotlight() {
            HmEventRegistry.fireEvent("INITIATE_GA");
            HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
            this.selectedMenu = "menuspotlight";
            return (
                <div>
                    <Spotlight showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()}></Spotlight>
                </div>
            );
    }

    Faq() {
            HmEventRegistry.fireEvent("INITIATE_GA");
            HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
            //this.selectedMenu = "menufaq";
            return (
                <div>
                    <FAQ />
                    <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
                </div>
            );
    }

    getSwitcher() {
            return (
                <Switch>
                    <Redirect from="/" exact to="/ke" />
    
                    <Route exact path='/ke' component={this.Home} maintainScrollPosition={true} />
                    <Route exact path='/home' component={this.Home} maintainScrollPosition={true} />
                    <Route path="/landing" exact component={Home} />
                    <Route path="/dashboard" exact component={Dashboard} />
                    <Route path="/settings" exact component={this.GetMyProfile} />
                    <Route path="/scorecard/:id/:reset?" exact component={Scorecard} />
                    <Route path='/our-learnings' component={this.Learnings} maintainScrollPosition={true} />
                    <Route path='/who-we-are' component={this.WhoWeAre} maintainScrollPosition={true} />
                    <Route path='/blog' component={this.Blog} maintainScrollPosition={true} />
                    <Route path='/spotlight' component={this.Spotlight} maintainScrollPosition={true} />
                    <Route path='/remedial' component={this.mobileLoginFn} maintainScrollPosition={false} /> 
                    <Route path="/faq" component={this.Faq} maintainScrollPosition={true} />
                    <Route exact path='/product-details' component={this.GetProductDetails} maintainScrollPosition={true} />
    
                    <Redirect from="/products" exact to={this.getGeo() + "/products"} />
    
                    <Route path='/in/products' component={this.newINCatalogue} maintainScrollPosition={true} />
                    <Route exact path='/sg/products' component={this.SGCatalogue} maintainScrollPosition={true} />
    
                    <Redirect from="/myproducts" to="/mysubscriptions" />
                    <Route path="/mysubscriptions" exact component={this.GetMyProducts} maintainScrollPosition={true} />
                    {/* 
        <Route path="/report" exact component={Report} />
        <Redirect from="/classes" to="/products"/>
        <Route path='/products' component={this.Products}  maintainScrollPosition={true}/>
        <Route path='/our-learnings' component={this.Learnings} maintainScrollPosition={true}/>
        <Route path='/who-we-are' component={this.WhoWeAre} maintainScrollPosition={true}/>
        <Route path='/blog' component={this.Blog} maintainScrollPosition={true}/>
        <Route path='/spotlight' component={this.Spotlight} maintainScrollPosition={true}/>
        <Route path="/faq" component={this.Faq} maintainScrollPosition={true} />
        <Route path='/self-learning/:id' component={this.SelfPaced} maintainScrollPosition={true}/>
        <Route path='/personalised-learning/:id' component={this.Plp} maintainScrollPosition={true}/>
        <Route path='/cbse-exam/:id' component={this.cbse} maintainScrollPosition={true}/>
        <Route exact path='/product-details' component={this.GetProductDetails} maintainScrollPosition={true}/>
        <Route exact path='/teachers' component={this.Teachers} maintainScrollPosition={true}/>
         */}
          <Route exact path="/undefined">
            {BrowserStorageUtil.getStoredItem("remedial") ? <Redirect to="/remedial" /> : <Redirect to="/" />}
            </Route>
                    {/* <Redirect from='*' to='/' /> */}
                    <Route exact path="/404" component={this.Home} />
                    <Route component={this.Home} />
                    <Redirect from='*' to='/' />
                </Switch>
            )
        }
    
        getRouter() {
            var me = this;
    
            return (
                <Router>
                    <div>
                        <header className="clearfix">
                            {/* <ContactHeader></ContactHeader> */}
                            <nav className="nav-desktop">
                                <div className="container-fluid norightpadding">
                                    <div className="logo"><Link className="heyMenu menuhome" data-classname="menuhome" to="/home" onClick={me.setPreloginClass}>{this.getHeaderLogo()}</Link></div>
    
    
                                    {(() => {
                                        if (me.state.LumosloggedIn) {
                                            return (<ul className="textAlignLeft"><span></span></ul>);
                                        } else if (me.state.loggedIn || me.state.PLPloggedIn) {
                                            return (
                                                <div>
                                                    {(() => {
                                                        if (me.isHeaderMenuAllowed("products")) {
                                                            return me.postLoginTchr();
                                                        } else {
                                                            return (<ul className="textAlignLeft"><span></span></ul>);
                                                        }
                                                    })()}
                                                </div>
                                            );
                                        } else {
                                            return (
                                                <ul>
                                                    <li data-ga="Home Tab" ><Link className="heyMenu menuhome" data-classname="menuhome" to="/" onClick={me.menuSelected}>Home</Link></li>
                                                    {/* {me.sgProductTab()} */}
                                                    {(() => {
                                                        if (!window.teachers_tab_suppressed) {
                                                            return <li data-ga="Teachers - Main Tab" ><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
                                                        }
                                                    })()}
    
                                                    {me.aboutUsTab()}
                                                </ul>
                                            );
                                        }
                                    })()}
    
    
                                    <div className="r-sec">
                                        {(() => {
                                            if (me.isHeaderMenuAllowed("my_heymath")) {
                                                return (<a id="sign_in_btn" data-ga="My HeyMath Tab" className={"r-btn myheymathbtn mr-30 " + me.getMargin()} onClick={me.showLoginForm}><img id="sign_in_btn_img" src="/img/kenya_flg_new.png"/> <span> {me.getButtonName()} &gt; </span> </a>);
                                            } else {
                                                return (<ul className="textAlignLeft"><span></span></ul>);
                                            }
                                        })()}
    
                                        {me.renderLoginView()}
                                    </div>
    
    
                                </div>
                            </nav>
    
                            {
                                (() => {
    
                                    if (this.isHeaderMenuAllowed("hamburger")) {
    
                                        return (
                                            <Menu right onStateChange={(state) => me.handleStateChange(state)} isOpen={me.state.menuOpen}>
    
                                                <div id="menu-icon-wrapper" className="menu-icon-wrapper">
                                                </div>
    
                                                <nav className="nav-mobile">
    
                                                    {(() => {
                                                        if (me.state.loggedIn && this.isHeaderMenuAllowed("hamburger")) {
                                                            return me.postLoginTchrTab();
                                                        } else if (this.isHeaderMenuAllowed("hamburger")) {
                                                            return (
                                                                <ul>
                                                                    <li data-ga="Home Tab" className="animated"><Link className="heyMenu menuhome" data-classname="menuhome" to="/" onClick={() => this.menuSelected()}>Home</Link></li>
    
                                                                    {/* <li data-ga="SG Prducts - Main Tab" className="animated"><Link className="heyMenu menusgproducts" data-classname="menusgproducts" to="/sg/products" onClick={() => this.menuSelected()}>{this.rb("sg.products.title")}</Link></li> */}
    
    
                                                                    {(() => {
                                                                        if (!window.teachers_tab_suppressed) {
                                                                            return <li data-ga="Teachers - Main Tab" className="animated"><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={() => this.menuSelected()}>Teachers</Link></li>
                                                                        }
                                                                    })()}
    
                                                                    <li data-ga="Our Learning - Main Tab" className="animated"><Link className="heyMenu menuourlearnings" data-classname="menuourlearnings" to="/our-learnings" onClick={() => this.menuSelected()}>Our Learnings</Link></li>
                                                                    <li data-ga="Who we are - Main Tab" className="animated"><Link className="heyMenu menuwhoweare" data-classname="menuwhoweare" to="/who-we-are" onClick={() => this.menuSelected()}>Who We Are</Link></li>
                                                                    {/* <li data-ga="Blog - Main Tab" className="animated"><Link className="heyMenu menublog" data-classname="menublog" to="/blog" onClick={() => this.menuSelected()}>Blog</Link></li> */}
                                                                    <li data-ga="Spotlight - Main Tab" className="animated"><Link className="heyMenu menuspotlight" data-classname="menuspotlight" to="/spotlight" onClick={() => this.menuSelected()}>Spotlight</Link></li>
                                                                </ul>
                                                            );
                                                        }
                                                    })()}
    
    
    
                                                </nav>
                                            </Menu>
                                        )
    
                                    } else {
                                        return null;
                                    }
    
                                })()
                            }
    
    
    
                        </header>
                        <div className="clearfix"></div>
                        {me.getSwitcher()}
    
                    </div>
                </Router>
            )
        }

    Home() {
	
			if (!this.tracked) {
			this.getAdsTracker().callByReferer({ "eventType": "trackCustom", "eventName": "home-PageView" });
			this.tracked = true;
		}

		try {
			if (this.state.LumosloggedIn) {
				var testId = this.getUrlParameter("testId") || 0;
				if(testId>0){
					window.location.href = this.getUrlFor("ANALYTICS_DOM_PERF_SUMMARY")+testId;
				}else{
					window.location.href = this.getUrlFor("LUMOS_REDIRECT_URL");
				}
				
			} else if (this.state.PLPloggedIn && !window.location.href.match("/home")) {
				window.location.href = "/landing";
			}
		} catch (e) { }

		this.selectedMenu = "menuhome";
		let addCls = (promotionMessage && promotionMessage.showBanner) ? "bgdimgreact" : false;
		var me = this;
		return (
			<div className='kenya'>
				{me.setTitle("HOME_title")}
				{me.setMeta("HOME_meta")}
				{me.setHeading("HOME_heading")}
				<div id="bannerElement">{this.getBannerContent()}</div>
				<ScrollToTopOnMount />
				<Banner addCls={addCls} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()} PLPloggedIn={this.state.PLPloggedIn} startFreeTrial={this.startFreeTrial} showSignUp={this.showSignUp} showNewLoginForm={this.showNewLoginForm}></Banner>
				{/*<LiveFeed PLPloggedIn={this.state.PLPloggedIn} showNewLoginForm={this.showLiveFeedLogin}/>*/}
				{/* <div id="promtionElement" className="promotionBanner">{this.getPromotionBannerContent()}</div> */}

				<RecognisedStatic></RecognisedStatic>
				<LessonFeatures></LessonFeatures>
				{/* <Experience products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Experience> */}
				<Why></Why>
				{/* <OurParents></OurParents> */}
				<OurTeachers></OurTeachers>
				<OurTestimonial></OurTestimonial>
				{/* <Testimonial></Testimonial> */}
				<StaticFeed>

				</StaticFeed>
				{/* <Featured></Featured> */}
				<SignupSection PLPloggedIn={this.state.PLPloggedIn} startFreeTrial={this.startFreeTrial} showSignUp={this.showSignUp} showNewLoginForm={this.showNewLoginForm}></SignupSection>
				<Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
				{this.fireMobileToast()}
			</div>
		);
	}

    WhoWeAre() {
            HmEventRegistry.fireEvent("INITIATE_GA");
            HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
            this.selectedMenu = "menuwhoweare";
            var me = this;
            return (
                <div>
                    {me.setTitle("WHO_WE_ARE_title")}
                    {me.setMeta("WHO_WE_ARE_meta")}
                    {me.setHeading("WHO_WE_ARE_heading")}
                    <ScrollToTopOnMount />
                    <WhoBanner></WhoBanner>
                    <DayInLife></DayInLife>
                    <Culture></Culture>
                    <Founders></Founders>
                    <Teampage></Teampage>
                    {/* <OurTeam></OurTeam> */}
                    <FounderVideos></FounderVideos>
                    {/*<ScholarsProgram></ScholarsProgram>*/}
                    <Recognised></Recognised>
                    <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
                </div>
            );
        }

    render() {
        return super.render(
            this.getRouter()
        );
    }
}

export default ke_PreloginHome;

ComponentRegistry.register("ke_PreloginHome", ke_PreloginHome);

/*
* Also registering for the users with hm_ prefix
*/
ComponentRegistry.register("hm_preloginhome", ke_PreloginHome);

/**
* IMPORTANT: Global Prelogin home for SG and other country users
*/
ComponentRegistry.register("PreloginHome", ke_PreloginHome);



// WEBPACK FOOTER //
// ./src/views/ke/ke_PreloginHome.js